import { useQuery } from '@tanstack/react-query';
import { ApiClient } from 'lib/api/client';
import { QUERY_KEYS } from 'settings/config';
import { useApiReady } from './use-api-ready';

/** Get the list of available subscription plans */
export function useMarketplaceConfig() {
  const enabled = useApiReady();

  return useQuery(
    [QUERY_KEYS.marketplaceConfig],
    () => new ApiClient().MarketplaceConfigApi.marketplaceConfigRetrieve(),
    {
      select: (data) => data.data,
      enabled,
    }
  );
}
